import { entity, persistence } from "simpler-state"
import { api_fetch } from "@/api/client.tsx"

export interface OrgSettings {
  has_product_services: boolean
  accounting_integration: string | null
  is_demo: boolean
  /** Forecast governance: admin-only version delete/lock/primary and the approval queue. */
  forecast_approvals_required: boolean
  /** In a governed org, whether a sales rep may change another rep's customers. */
  forecast_reps_edit_others?: boolean
  /** The Sales team does not get the accounting pages (Settings > Organization). */
  hide_accounting_from_sales?: boolean
}

const INITIAL_ORG_SETTINGS: OrgSettings = {
  has_product_services: false,
  accounting_integration: null,
  is_demo: false,
  forecast_approvals_required: false,
}

export const OrgSettingsState = entity<OrgSettings>(INITIAL_ORG_SETTINGS, [
  persistence("org_settings"),
])

export async function loadOrgSettings() {
  const result = await api_fetch<OrgSettings>("/organization/settings")
  if (result.ok) {
    OrgSettingsState.set(result.value.data)
  }
}

export function useOrgSettings(): OrgSettings {
  return OrgSettingsState.use()
}
